import { useRef, useEffect } from 'react';
import ddt from '@wix/da-ddt';
const logger = ddt.createLogger('react');

// this is a helper to help debug re-renders

function objectDiff<T extends {}>(from: T, to: T) {
  const diff: Partial<T> = {};

  Object.keys({ ...from, ...to }).forEach(key => {
    if (from[key] !== to[key]) {
      diff[key] = {
        from: from[key],
        to: to[key],
      };
    }
  });
  return diff;
}

export function useDebugRerenders<T extends {}>(name: string, props: T) {
  const previousProps = useRef<T>(undefined);

  useEffect(() => {
    if (previousProps.current) {
      const diff = objectDiff(previousProps.current, props);
      if (Object.keys(diff).length) {
        logger.log(`${name} re-render reason:`, diff);
      } else {
        logger.log(`${name} re-rendered without prop changes`);
      }
    }

    previousProps.current = props;
  });
}
